module.exports = __webpack_public_path__ + "img/farewell_4.d4052b75.jpg";